import React from "react";
import {DiffOutlined} from "@ant-design/icons";
import {Table, TableVariants, Text, TextAs, TextSizes} from "@clockout-dev/design-elements";
import SectionCard from "../../common/sectionCard/SectionCard";
import SeverityPill from "./SeverityPill";
import styles from "../styles/results.module.scss";

function formatValue(value) {
    if (value === null || value === undefined || value === "") return "—";
    if (typeof value === "object") return JSON.stringify(value);
    return String(value);
}

/**
 * All contradictions between the document and the authored SOR — every
 * severity, not just the rejecting ones. Production redacts this table
 * entirely; here it is the core of the demo.
 *
 * @param {Object} props
 * @param {Object[]} [props.contradictions] — verdict `contradictions`
 */
function ContradictionsCard({contradictions}) {
    const rows = Array.isArray(contradictions) ? contradictions : [];

    const columns = [
        {title: "Field", dataIndex: "field", key: "field", render: value => formatValue(value)},
        {title: "SOR value", dataIndex: "sor", key: "sor", render: value => formatValue(value)},
        {title: "Document value", dataIndex: "uploaded", key: "uploaded", render: value => formatValue(value)},
        {title: "Severity", dataIndex: "severity", key: "severity", render: severity => <SeverityPill severity={severity} />},
        {title: "Note", dataIndex: "reason", key: "reason", render: value => formatValue(value)}
    ];

    return (
        <SectionCard icon={<DiffOutlined />} title={`Contradictions (${rows.length})`}>
            <div className={styles.tableScroll}>
                <Table
                    variant={TableVariants.DEFAULT}
                    columns={columns}
                    dataSource={rows.map((row, index) => ({...row, __key: index}))}
                    rowKey="__key"
                    pagination={false}
                    emptyDescription="No contradictions against the SOR"
                />
            </div>
            <Text as={TextAs.P} size={TextSizes.EXTRA_SMALL} className={styles.cardFootnote}>
                Only HIGH severity contradictions reject a document — low and medium are recorded silently.
            </Text>
        </SectionCard>
    );
}

export default ContradictionsCard;
